<template>
<div>
        <loader v-if="loading" />
        <div v-if="!loading && (data.Enrolment > 0 || data.Quota > 0)">
            <v-list>
                <v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title>Enrolment</v-list-tile-title>
                        <v-list-tile-sub-title>{{ data.Enrolment }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title>Quota</v-list-tile-title>
                        <v-list-tile-sub-title>{{ data.Quota }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>                                      
            </v-list>
        </div>
</div>
</template>
<script>
    import Loader from '@/components/Loader.vue';
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;
    export default {
        props: ['state', 'year'],
        components: {
            Loader
        },
        data() {
            return {
                data: {},
                loading: true
            }
        },
        created() {
            this.initialiseData();
        },
        methods: {
            initialiseData: function () {
                const url = `Elections/SenateStateStatistics?state=${this.state}&year=${this.year}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.data = response.data;
                        this.loading = false;
                    });
            }
        }
    }
</script>